module.exports = __webpack_public_path__ + "img/step-3.c3517c61.svg";